import { ApiClient } from "lib/utils/client/apiClient"

export const builderPropertiesCount= async (id: string) => {
    return ApiClient(`/builder-user/properties-count/${id}`,{
        method: 'GET',
    });
};

export const builderPropertiesListing = async (data: {id: string,status: string,property_category?:string, search?: string, page: number, limit: number}) => {
    return ApiClient(`/builder-user/properties-listing`,{
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const focalPersonListing = async (data : {id: string, search?: string, page: number, limit: number}) => {
    return ApiClient(`/builder-user/focal-person/details`,{
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const builderDocumentsListing = async (id:string) => {
    return ApiClient(`/builder-user/documents/${id}`,{
        method: 'GET',
    });
};

export const updateBuilderDocumentStatus = async (data:{builder_id: string,document_id:string, status: string}) => {
    return ApiClient(`/builder-user/documents/update`,{
        method: 'PATCH',
        body: JSON.stringify(data)
    });
};

export const UserRolesListing = async (data : {id: string, search?: string, page: number, limit: number}) => {
    return ApiClient(`/user-roles/listing-details`,{
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const specificUserRoleData = async (id:string) => {
    return ApiClient(`/user-roles/${id}/details`,{
        method: 'GET',
    });
};

export const updateSpecificUserRoleDetails= async(data:{userRoleId:string, full_name?:string, phone_no?:string, status?:string}) => {
   return ApiClient(`/user-roles/update-user`,
      {
         method: 'PATCH',
         body: JSON.stringify(data)
      }
   )
};